const VIEWER_LEVEL_IDS = new Set(["VIW", "VWR"]);

export function isViewerLevel(levelID, levelName = "") {
  const normalizedID = String(levelID || "").trim().toUpperCase();
  const normalizedName = String(levelName || "").trim().toUpperCase();
  return VIEWER_LEVEL_IDS.has(normalizedID) || normalizedName === "VIEWER";
}
